module.exports = __webpack_public_path__ + "img/story10-graz-1.jpg";